import React, { Component } from 'react';
import { withTheme } from '@material-ui/core/styles';
import 'react-credit-cards/es/styles-compiled.css';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import withCustomTheme from '../../components/HOC/HOCwithCustomTheme.jsx';
import { Paper, Table, TableHead, TableBody, TableCell, TableRow, Button } from '@material-ui/core';
import moment from 'moment';
class Status extends Component {
    constructor(props) {
        super();
        this.state = {
            card_payment_detail: [],
            rejected_services: [],
            hourly_booked_services: [],
            package_booked_services: []
        };
    }

    componentDidMount() {
        this.setState({
            rejected_services: this.props.location.state.rejected_services,
            card_payment_detail: this.props.location.state.card_payment_detail,
            hourly_booked_services: this.props.location.state.hourly_booked_services,
            package_booked_services: this.props.location.state.package_booked_services

        })
    }


    render() {
        const { rejected_services, card_payment_detail, hourly_booked_services, package_booked_services } = this.state

        return (
            <div>
                <div
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        height: '80px',
                        width: '100%'
                    }}
                />

                <div className="creat-booking-page">
                    <div className="container">
                        <div className="dir-alp-con dir-alp-con-1">
                            <h2 className="mb-4">Booking Confirmation</h2>
                            {hourly_booked_services.length > 0 &&
                                <Paper style={{ marginTop: 10, marginBottom: 10 }}>
                                    <div style={{ overflowX: "auto" }}>
                                        <Table style={{ minWidth: 650 }}>
                                            <TableHead>
                                                <TableCell style={{ padding: 20 }}>
                                                    <h4>Hourly Services</h4>
                                                </TableCell>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <p>Confirmation #</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Time</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Name</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Quantity</p>
                                                    </TableCell>
                                                </TableRow>

                                            </TableBody>
                                            {hourly_booked_services.length > 0 && hourly_booked_services.map((item, index) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell align="right">
                                                                <p>{item.token}</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{moment(item.datetime).format("MM-DD-YYYY")}</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{item.services[0].service}</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{item.services[0].quantity}</p>
                                                            </TableCell>
                                                        </TableRow>

                                                    </TableBody>
                                                )
                                            })}
                                        </Table>
                                    </div>
                                </Paper>}
                            {package_booked_services.length > 0 &&
                                <Paper style={{ marginTop: 10, marginBottom: 10 }}>
                                    <div style={{ overflowX: "auto" }}>
                                        <Table style={{ minWidth: 650 }}>
                                            <TableHead>
                                                <TableCell style={{ padding: 20 }}>
                                                    <h4>Package Services</h4>
                                                </TableCell>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <p>Token</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Time</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Name</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Quantity</p>
                                                    </TableCell>
                                                </TableRow>

                                            </TableBody>
                                            {package_booked_services.length > 0 && package_booked_services.map((item, index) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell align="right">
                                                                <p>{item.token}</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{moment(item.datetime).format("MM-DD-YYYY")}</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{item.services[0].service}</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{item.services[0].quantity}</p>
                                                            </TableCell>
                                                        </TableRow>

                                                    </TableBody>
                                                )
                                            })}
                                        </Table>
                                    </div>
                                </Paper>}

                            {rejected_services.length > 0 &&
                                <Paper style={{ marginTop: 10, marginBottom: 10 }}>
                                    <div style={{ overflowX: "auto" }}>
                                        <Table style={{ minWidth: 650 }}>
                                            <TableHead>
                                                <TableRow style={{ padding: 20 }}>
                                                    <TableCell colSpan={2} >
                                                        <h4>Rejected Services</h4>
                                                    </TableCell>
                                                    <TableCell align="right" colSpan={2} style={{ textAlign: "right" }}>
                                                        <Button onClick={() => {
                                                            this.props.history.push({
                                                                pathname: `/book/service/2912adarsh1245/`,
                                                                state: { serviceDataSource: rejected_services }
                                                            });
                                                        }} style={{ alignSelf: "right" }} variant="contained" color="primary">
                                                            Rebook
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>

                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <p>Booking Status</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Message</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Name</p>
                                                    </TableCell>
                                                    <TableCell>
                                                        <p>Quantity</p>
                                                    </TableCell>
                                                </TableRow>

                                            </TableBody>
                                            {rejected_services.length > 0 && rejected_services.map((item, index) => {
                                                return (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell align="right">
                                                                <p>Booking Failed</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{item.message}</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{item.heading}</p>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <p>{item.qty}</p>
                                                            </TableCell>
                                                        </TableRow>

                                                    </TableBody>
                                                )
                                            })}
                                        </Table>
                                    </div>
                                </Paper>}
                            <div style={{ width: "100%", padding: 20, flexDirection: "row", justifyContent: "space-between", display: "flex", marginTop: 20 }}>
                                <Button variant="contained" color="primary" onClick={() => {
                                    this.props.history.replace({
                                        pathname: `/`
                                    });
                                }}>
                                    Go To Home
                                    </Button>
                                <Button variant="contained" color="primary" onClick={() => {
                                    this.props.history.replace({
                                        pathname: `/user/booking/`
                                    });
                                }}>
                                    Booking List
                                    </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        backgroundColor: "#fbf7eb",
                        height: '80px',
                        width: '100%'
                    }}
                />
            </div>
        );
    }
}
const composedComponent = compose(withTheme(), connect(null, actions));
export default composedComponent(withCustomTheme(injectIntl(Status)));



// WEBPACK FOOTER //
// ./src/views/Booking/Status.jsx